import { render, staticRenderFns } from "./CourseCompareToggle.vue?vue&type=template&id=1a380b32&"
import script from "./CourseCompareToggle.vue?vue&type=script&lang=js&"
export * from "./CourseCompareToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports